module.exports = __webpack_public_path__ + "static/media/irritert.1b76a181.m4a";